@if (style === 'e-btn') {
  <button ejs-button
    [type]="type"
    [class]="getButtonClass()"
    [disabled]="(disabled) || (loadingService.loadingIndicator$ | async)"
    [attr.aria-label]="text">
    <!-- Left Icon -->
    @if (icon && iconPosition === 'left') {
      <span [class]="'mts-icon ' + iconClass">{{ icon }}</span>
    }
    <!-- Button Content -->
    @if (text) {
      <span
        [class]="textClass"
        [class.px-1]="icon || !icon"
        [class.d-none]="hideTextOnMobile"
        [class.d-md-inline]="hideTextOnMobile"
      >{{text}}</span>
    }
    <!-- Right Icon -->
    @if (icon && iconPosition === 'right') {
      <span [class]="'mts-icon ' + iconClass">{{ icon }}</span>
    }
  </button>
}

@if (style === 'btn') {
  <button type="button"
    class="btn lh-1 d-flex align-items-center"
    [class]="cssClass"
    [disabled]="(disabled) || (loadingService.loadingIndicator$ | async)"
    [attr.aria-label]="text">
    <!-- Left Icon -->
    @if (icon && iconPosition === 'left') {
      <span [class]="'mts-icon aling-webkit-middle ' + iconClass">{{ icon }}</span>
    }
    <!-- Button Content -->
    @if (text) {
      <span
        [class]="textClass"
        [class.px-1]="icon || !icon"
        [class.aling-webkit-middle]="icon"
        [class.d-none]="hideTextOnMobile"
        [class.d-md-inline]="hideTextOnMobile"
      >{{text}}</span>
    }
    <!-- Right Icon -->
    @if (icon && iconPosition === 'right') {
      <span [class]="'mts-icon aling-webkit-middle ' + iconClass">{{ icon }}</span>
    }
  </button>
}
